import { LinkSize } from 'omakase/Link/Link';
import { OmakaseTypographyVariant } from 'theme/typography/omakaseTypography';
import { Theme, css } from '@emotion/react';
import { assertNever } from '@tock/shared/utils/typeUtils';

export const adornedLinkOnlyBaseStyles = (theme: Theme) => css`
  display: inline-flex;
  align-items: baseline;
  justify-content: flex-start;
  gap: ${theme.spacing(0.5)}px;
`;

export const colorStyles = (theme: Theme) => css`
  color: ${theme.colors.fgPrimaryBase};
  ${theme.interactiveStates.hover(css`
    color: ${theme.colors.bgPrimaryDark};
  `)}
  ${theme.interactiveStates.active(css`
    color: ${theme.colors.fgPrimaryDark};
  `)}
  &.MuiLink-root:visited {
    color: ${theme.colors.fgPrimaryDark};
  }
`;

export const disabledStyles = (theme: Theme) => css`
  color: ${theme.colors.fgDisabled};
  cursor: auto;
`;

export const sharedBaseStyles = (theme: Theme) => css`
  cursor: pointer;
  outline: none;
  ${theme.interactiveStates.focus(css`
    box-shadow:
      inset 0px -1.5px 0px currentColor,
      0 0 0 2px ${theme.colors.borderPrimaryBase};
  `)}
`;

function getTypographyVariantFromSize(size: LinkSize): OmakaseTypographyVariant {
  switch (size) {
    case 'small':
      return 'caption';
    case 'medium':
      return 'body02';
    case 'large':
      return 'body01';
    case 'jumbo':
      return 'heading04';
    default:
      assertNever(size);
  }
}

export const size = (size?: LinkSize) => (theme: Theme) =>
  size
    ? css`
        ${theme.typography.variant(getTypographyVariantFromSize(size))}
      `
    : null;

function getIconSizeFromSize(size: LinkSize): number {
  switch (size) {
    case 'small':
      return 1.6;
    case 'medium':
      return 2.0;
    case 'large':
      return 2.0;
    case 'jumbo':
      return 2.4;
  }
}

export const icon = (size?: LinkSize) => (theme: Theme) => {
  const iconDiameter = getIconSizeFromSize(size ?? 'medium');

  return css`
    width: ${iconDiameter}rem;
    & svg {
      height: auto;
      vertical-align: ${size ? 'bottom' : 'middle'};
      width: 100%;
    }
  `;
};
